import { useIntl } from 'react-intl';
import { UpdateGroupDto} from '../../../../../api-client';
import { EditGroupDetailsComponent } from './EditGroupDetailsModal.types';
import { useGroupForm } from '../../../../GroupList/hooks/useGroupForm';
import { Box, Modal, TextField, Typography } from '@hiiretail/synergy-ui';
import { ErrorBox } from '../../../../../common/components/ErrorBox/ErrorBox';
import { Controller } from 'react-hook-form';
import { AccessDeniedButton } from '../../../../../common/styles/AccessDenied.styles';
import { PrimaryButton, SecondaryButton, StyledContainer } from './EditGroupDetailsModal.styles';
import { AccessControl, CommonMessages } from '../../../../../common';

export const EditGroupDetailsModal: EditGroupDetailsComponent = ({
  group,
  updateGroup,
  updateError,
  isUpdating,
  closeEditGroupDetailsModal,
  isEditGroupDetailsModalOpen,
  onGroupEditionSuccess,
}) => {
  const intl = useIntl();
  const { control, handleSubmit, formState, reset } = useGroupForm(intl);

  const onFormSubmit = (formData: UpdateGroupDto) => {
    updateGroup(formData, {
      onSuccess: onGroupEditionSuccess,
    });
  };

  return (
    <Modal
      open={isEditGroupDetailsModalOpen}
      onClose={closeEditGroupDetailsModal}
      // @ts-ignore
      title={<Typography variant="header2">Edit group details</Typography>}
    >
      <ErrorBox error={updateError} />
      <form>
        <StyledContainer container item justifyContent="space-between">
          <Controller
            name="name"
            defaultValue={group?.name}
            control={control}
            render={({ field: { value, onChange } }) => (
              <TextField
                name="name"
                placeholder="Nord Admins"
                label={intl.formatMessage(CommonMessages.name)}
                type="text"
                autoComplete="name"
                value={value}
                onChange={onChange}
                error={formState.errors?.name?.message}
                fullWidth
                disabled={isUpdating}
              />
            )}
          />
        </StyledContainer>

        <StyledContainer container item justifyContent="space-between">
          <Controller
            name="description"
            defaultValue={group?.description}
            control={control}
            render={({ field: { value, onChange } }) => (
              <TextField
                placeholder="The group contains members for..."
                label="Description"
                name="description"
                autoComplete="description"
                type="text"
                value={value}
                onChange={onChange}
                error={formState.errors?.description?.message}
                fullWidth
                disabled={isUpdating}
              />
            )}
          />
        </StyledContainer>

        <StyledContainer container item  justifyContent="flex-end">
          <SecondaryButton type="reset" variant="secondary" onClick={() => reset({ name: "", description: "" })}>Reset</SecondaryButton>
          <Box mr={4} />
          <AccessControl
            permission="iam.group.update"
            renderIfNoAccess={
              <AccessDeniedButton disabled>Update</AccessDeniedButton>
            }
          >
            <PrimaryButton
              disabled={
                isUpdating
                || !!Object.values(formState.errors).length
                || !Object.values(formState.dirtyFields).length
              }
              onClick={handleSubmit(onFormSubmit)}
            >
              {isUpdating ? 'Updating' : 'Update'}
            </PrimaryButton>
          </AccessControl>
        </StyledContainer>
      </form>
    </Modal>
  );
};
